import { type ColumnType } from 'antd/es/table';
import { type IIdentifyFeature } from '../drawing/identify/IIdentifyResult.ts';

/**
 * Costruisce le colonne dinamiche di una tabella dagli attributi delle
 * feature interrogate. Il titolo usa l'alias quando disponibile,
 * altrimenti il nome dell'attributo.
 */
export function getAttributesColumnsFromFeatures(
  features: IIdentifyFeature[],
  aliases?: Record<string, string>,
): ColumnType<IIdentifyFeature>[] {
  const attrKeys = new Set<string>();
  for (const feature of features) {
    for (const key of Object.keys(feature.attributes)) {
      attrKeys.add(key);
    }
  }

  return Array.from(attrKeys).map(key => ({
    title: aliases?.[key] || key,
    dataIndex: ['attributes', key],
    key,
    render: (value: unknown) => {
      const text = value == null ? '' : String(value).trim();
      return text || '—';
    },
  }));
}
